export default __webpack_public_path__ + "static/media/escape.0db78ac3.svg";